import React from "react";
import { useViewerDecks } from "queries/viewerQuery";
import { CardValues } from "components/ReduxProvider";
import { useSpeakingStarterText } from "root/main/main/quests/misc/useSpeakingStarters";
import { useTranslates } from "hooks/useTranslates";
import { AssistantMode } from "components/assistant/__generated__/AssistantMutation.graphql";

export const useInitialMessageText = (options: { cardContext?: CardValues }) => {
  const { deck } = useViewerDecks();
  const { cardContext } = options;
  const { starter: speakingInitialMessage } = useSpeakingStarterText();

  const { translates, isLoadingTranslates } = useTranslates(
    deck?.front || "",
    [
      "Hi! I am your AI language assistant. Ask me any question!",
      "I see that you're learning the card <1/>, do you want to know more about it?"
    ],
    !deck
  );
  const [firstMessageText, cardDetailModeMessageRaw] = translates;
  const cardDetailModeMessage: string | undefined = cardDetailModeMessageRaw?.replace(
    "<1/>",
    `"<b>${cardContext?.front || ""}</b>"`
  );

  const getInitialMessageText = React.useCallback(
    (mode: AssistantMode): string | undefined => {
      const messageMap: Partial<Record<AssistantMode, string | undefined>> = {
        cardDetail: cardDetailModeMessage,
        speaking: speakingInitialMessage,
        listenVocab: "",
        letsPractise: "",
        aiStory: ""
      };

      return messageMap[mode] ?? firstMessageText;
    },
    [cardDetailModeMessage, speakingInitialMessage, firstMessageText]
  );

  return {
    getInitialMessageText,
    loading: isLoadingTranslates || !speakingInitialMessage
  };
};
